import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, map, of, switchMap, withLatestFrom } from 'rxjs';

import { MoreMetricsOption } from '../more-metrics.types';
import { MeterMoreMetricsApiService } from '../meter-more-metrics-api.service';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import { MeterMoreMetricsActions } from './meter-more-metrics.actions';
import { selectSelectedOptionId } from './meter-more-metrics.reducer';

export const loadOptions$ = createEffect(
  (actions$ = inject(Actions), apiService = inject(MeterMoreMetricsApiService), tzService = inject(TimezoneService)) =>
    actions$.pipe(
      ofType(MeterMoreMetricsActions.loadOptions),
      switchMap(({ deviceUID, dateRange }) => {
        const { start, end } = tzService.getDatepickerRange({ start: dateRange.start, end: dateRange.end });
        return apiService.getOptions(deviceUID, start, end).pipe(
          map(options => MeterMoreMetricsActions.loadOptionsSuccess({ options })),
          catchError(() => of(MeterMoreMetricsActions.loadOptionsFailure({ error: 'Failed to load options' })))
        );
      })
    ),
  { functional: true }
);

export const clearIfUnavailable$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store)) =>
    actions$.pipe(
      ofType(MeterMoreMetricsActions.loadOptionsSuccess),
      withLatestFrom(store.select(selectSelectedOptionId)),
      filter(
        ([action, selectedOptionId]: [{ options: MoreMetricsOption[] }, string | null]) =>
          selectedOptionId !== null &&
          !action.options.some((o: MoreMetricsOption) => o.valueTypeId === selectedOptionId)
      ),
      map(() => MeterMoreMetricsActions.clearOption())
    ),
  { functional: true }
);
